/* =========================================================
   ACCESSIBILITY FIXES FOR SHOPIFY / NOTABLE THEME
   Replace the whole file with this code
   ========================================================= */

/* Run all fixes when the page finishes loading */
document.addEventListener('DOMContentLoaded', function () {
  fixRatingRoleImg();
  fixDnsIconPresentationRole();
  fixEmptyHeadings();
  fixFocusableInsideAriaHidden();
  fixMenuSummaryMarkup();
  fixFooterLandmark();
  fixFooterPaymentHiddenText();
  fixBrokenSliderLists();
  fixLandmarks();
  watchForDynamicChanges();
});

/* =========================================================
   FIX 1: STAR RATINGS
   Removes role="img" from rating wrappers and keeps
   readable text for screen readers
   ========================================================= */
function fixRatingRoleImg() {
  var ratings = document.querySelectorAll('.rating[role="img"]');

  ratings.forEach(function (rating) {
    var label = rating.getAttribute('aria-label');

    rating.removeAttribute('role');
    rating.removeAttribute('aria-label');

    var stars = rating.querySelector('.rating-star');
    if (stars) {
      stars.setAttribute('aria-hidden', 'true');
    }

    if (label && !rating.querySelector('.rating-screen-reader-text')) {
      var srText = document.createElement('span');
      srText.className = 'visually-hidden rating-screen-reader-text';
      srText.textContent = label;
      rating.appendChild(srText);
    }
  });
}

/* =========================================================
   FIX 2: REMOVE BAD role="presentation" FROM PRIVACY ICON
   ========================================================= */
function fixDnsIconPresentationRole() {
  var icons = document.querySelectorAll('.shopify-dns-link-icon[role="presentation"]');

  icons.forEach(function (icon) {
    icon.removeAttribute('role');
  });
}

/* =========================================================
   FIX 3: HIDE EMPTY HEADINGS
   Empty headings confuse screen readers
   ========================================================= */
function fixEmptyHeadings() {
  var headings = document.querySelectorAll('h1, h2, h3, h4, h5, h6');

  headings.forEach(function (heading) {
    var text = heading.textContent.replace(/\s+/g, '').trim();

    if (!text) {
      heading.setAttribute('hidden', 'hidden');
      heading.setAttribute('aria-hidden', 'true');
    }
  });
}

/* =========================================================
   FIX 4: REMOVE aria-hidden FROM AREAS WITH CLICKABLE ITEMS
   Clickable things should not live inside aria-hidden areas
   ========================================================= */
function fixFocusableInsideAriaHidden() {
  var hiddenContainers = document.querySelectorAll('[aria-hidden="true"]');

  hiddenContainers.forEach(function (container) {
    var focusable = container.querySelectorAll(
      'a, button, input, select, textarea, summary, [tabindex]:not([tabindex="-1"])'
    );

    if (focusable.length > 0) {
      container.removeAttribute('aria-hidden');

      if (container.getAttribute('role') === 'presentation') {
        container.removeAttribute('role');
      }
    }
  });
}

/* =========================================================
   FIX 5: SUMMARY MENUS
   Keep summary as the only interactive control
   ========================================================= */
function fixMenuSummaryMarkup() {
  var summaries = document.querySelectorAll('.details--list-menu > summary');

  summaries.forEach(function (summary) {
    summary.removeAttribute('role');

    /* Remove old helper text if we added it before */
    var oldHelper = summary.querySelector('.summary-screen-reader-text');
    if (oldHelper) {
      oldHelper.remove();
    }

    /* Remove nested interactive elements from keyboard focus */
    var nestedFocusable = summary.querySelectorAll(
      'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    nestedFocusable.forEach(function (child) {
      child.setAttribute('tabindex', '-1');
      child.setAttribute('aria-hidden', 'true');
    });

    /* If there is no readable text at all, add aria-label */
    var visibleText = summary.textContent.replace(/\s+/g, ' ').trim();
    if (!visibleText) {
      summary.setAttribute('aria-label', 'Open menu');
    }
  });
}

/* =========================================================
   FIX 6: FOOTER LANDMARK
   Makes sure footer is announced as footer content
   ========================================================= */
function fixFooterLandmark() {
  var footer = document.querySelector('.site-footer, footer');

  if (footer) {
    if (!footer.matches('footer')) {
      footer.setAttribute('role', 'contentinfo');
    }

    if (!footer.getAttribute('aria-label')) {
      footer.setAttribute('aria-label', 'Footer');
    }
  }
}

/* =========================================================
   FIX 7: PAYMENT AREA LABEL
   Gives the payment icon area a readable label
   ========================================================= */
function fixFooterPaymentHiddenText() {
  var paymentArea = document.querySelector('.footer__payment');

  if (paymentArea) {
    if (!paymentArea.hasAttribute('role')) {
      paymentArea.setAttribute('role', 'group');
    }

    if (!paymentArea.hasAttribute('aria-label')) {
      paymentArea.setAttribute('aria-label', 'Accepted payment methods');
    }
  }
}

/* =========================================================
   FIX 8: BROKEN GALLERY / THUMBNAIL LISTS
   Helps sliders that break list markup
   ========================================================= */
function fixBrokenSliderLists() {
  var galleries = document.querySelectorAll(
    '.product-single__gallery, .product-single__thumbnails, [class*="product-single__thumbnails"], [class*="product-single__gallery"]'
  );

  galleries.forEach(function (list) {
    /* Remove unsafe hiding if list has clickable items */
    if (list.getAttribute('aria-hidden') === 'true') {
      var focusable = list.querySelectorAll(
        'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );

      if (focusable.length > 0) {
        list.removeAttribute('aria-hidden');
        if (list.getAttribute('role') === 'presentation') {
          list.removeAttribute('role');
        }
      }
    }

    /* If a UL has bad children like DIVs, turn it into a group */
    var tagName = list.tagName ? list.tagName.toLowerCase() : '';
    var invalidChildFound = false;

    if (tagName === 'ul' || tagName === 'ol') {
      Array.from(list.children).forEach(function (child) {
        var childTag = child.tagName ? child.tagName.toLowerCase() : '';
        if (childTag !== 'li' && childTag !== 'script' && childTag !== 'template') {
          invalidChildFound = true;
        }
      });

      if (invalidChildFound) {
        list.setAttribute('role', 'group');
        list.setAttribute('aria-label', 'Product media gallery');
      }
    }
  });

  /* If LI items got moved into a DIV by the slider, add backup roles */
  var orphanLis = document.querySelectorAll('.slick-track > li.product-single__gallery-item');

  orphanLis.forEach(function (li) {
    var parent = li.parentElement;
    if (!parent) return;

    var parentTag = parent.tagName ? parent.tagName.toLowerCase() : '';
    if (parentTag !== 'ul' && parentTag !== 'ol') {
      if (!parent.hasAttribute('role')) {
        parent.setAttribute('role', 'list');
      }
      li.setAttribute('role', 'listitem');
    }
  });
}

/* =========================================================
   FIX 9: LANDMARKS
   Adds labels to key sections if theme markup misses them
   ========================================================= */
function fixLandmarks() {
  var main = document.querySelector('#MainContent');
  if (main && main.tagName.toLowerCase() !== 'main') {
    main.setAttribute('role', 'main');
  }

  var newsletter = document.querySelector('.newsletter-section');
  var newsletterHeading = document.querySelector('.newsletter-section__heading');

  if (newsletter && newsletterHeading) {
    if (!newsletterHeading.id) {
      newsletterHeading.id = 'NewsletterHeading';
    }
    if (!newsletter.hasAttribute('aria-labelledby')) {
      newsletter.setAttribute('aria-labelledby', newsletterHeading.id);
    }
    if (!newsletter.hasAttribute('role') && newsletter.tagName.toLowerCase() !== 'section') {
      newsletter.setAttribute('role', 'region');
    }
  }

  var subfooter = document.querySelector('.subfooter-section');
  if (subfooter && !subfooter.hasAttribute('role')) {
    subfooter.setAttribute('role', 'region');
    subfooter.setAttribute('aria-label', 'Subfooter');
  }
}

/* =========================================================
   FIX 10: WATCH FOR SHOPIFY / SLIDER CHANGES
   Re-runs fixes if the page updates itself
   ========================================================= */
function watchForDynamicChanges() {
  var observer = new MutationObserver(function () {
    fixRatingRoleImg();
    fixDnsIconPresentationRole();
    fixEmptyHeadings();
    fixFocusableInsideAriaHidden();
    fixMenuSummaryMarkup();
    fixFooterLandmark();
    fixFooterPaymentHiddenText();
    fixBrokenSliderLists();
    fixLandmarks();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}